var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TopBarControlWrapper',[_c('AppDropdown',{attrs:{"options":_vm.options,"selected-value":_vm.selectedValue,"dropdown-style":_vm.dropdownStyle,"size":_vm.size},on:{"selectedOptionChange":_vm.selectedOptionChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }